import React from 'react';
import { CustomPicker } from 'react-color';
import {
  EditableInput,
  Saturation,
  Hue,
} from 'react-color/lib/components/common';
import pt from 'prop-types';

import SwellColorPickerPreset from './color-picker-preset';

function CustomPointerSaturation({ hex }) {
  return (
    <div className="storefront-editor--color-scheme--picker--saturation-pointer">
      <div style={{ backgroundColor: hex }} />
    </div>
  );
}

CustomPointerSaturation.propTypes = {
  hex: pt.string.isRequired,
};

function CustomPointerHue({ hsl }) {
  return (
    <div className="storefront-editor--color-scheme--picker--hue-pointer">
      <div style={{ backgroundColor: `hsl(${hsl.h} 100% 50%)` }} />
    </div>
  );
}

CustomPointerHue.propTypes = {
  hsl: pt.shape({ h: pt.number.isRequired }).isRequired,
};

const SwellColorPicker = CustomPicker((props) => {
  const { hex, presetColors, onChange, onApply, onCancel } = props;

  return (
    <React.Fragment>
      <div className="storefront-editor--color-scheme--picker-content">
        <div className="color-solid-saturation">
          <Saturation
            {...props}
            pointer={CustomPointerSaturation}
            className="storefront-editor--color-scheme--picker--saturation"
          />
        </div>

        <div className="color-solid-hue">
          <Hue
            {...props}
            pointer={CustomPointerHue}
            className="storefront-editor--color-scheme--picker--hue"
          />
        </div>

        <div className="storefront-editor--color-scheme--picker--input-wrapper">
          <div
            className="storefront-editor--color-scheme--picker--preview"
            style={{ backgroundColor: hex }}
          />

          <EditableInput
            value={hex}
            className="storefront-editor--color-scheme--picker--input"
            onChange={onChange}
          />
        </div>

        <SwellColorPickerPreset presets={presetColors} onChange={onChange} />
      </div>

      <div className="storefront-editor--color-scheme--picker--actions">
        <button
          className="button button-sm button-secondary"
          onClick={onCancel}
          type="button"
        >
          Cancel
        </button>

        {/* <button
          className="button button-sm button-default"
          onClick={onApply}
          type="button"
        >
          Apply
        </button> */}
      </div>
    </React.Fragment>
  );
});

export default React.memo(SwellColorPicker);
